/*
 Copyright 2023 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

import { EntityState, EntityStore, Store, StoreConfig } from '@datorama/akita';
import { ScenarioEvent } from 'src/app/generated/blueprint.api';
import { Injectable } from '@angular/core';

export interface ScenarioEventState extends EntityState<ScenarioEvent> {}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'scenarioEvents' })
export class ScenarioEventStore extends EntityStore<ScenarioEventState> {
  constructor() {
    super();
  }
}
